import Link from 'components/links/Link';
import React from 'react';
import { Tooltip } from 'react-tippy';

export function PhotoContestBadge() {
    return (
        <div className="absolute top-2 left-2">
            <Tooltip
                title="Nagradni foto izbor"
                size="small"
                arrow={false}
                position="top"
                distance={3}
                popperOptions={{
                    modifiers: {
                        hide: { enabled: false },
                        preventOverflow: {
                            enabled: false
                        },
                        flip: {
                            enabled: false
                        },
                        offset: {
                            enabled: true,
                            offset: '10,0'
                        }
                    }
                }}
                animation="fade"
            >
                <Link to="/foto-izbor">
                    <img src="/images/foto-izbor/badge.svg" alt="Nagradni foto izbor" className="w-8" />
                </Link>
            </Tooltip>
        </div>
    );
}
